import React, { useEffect, useState } from "react";
import { getRoleLabel, isBRCGSUser, isMegatronFeatureOn } from "../../Authentication/Auth";
import DataTable, { DataTableQueryParams, Pagination } from "../DataTable";
import { UserRow } from "./models/UserRow";
import axiosApi from "../Api/Axios";
import SearchResponses from "../../Models/APIGetData/SearchResponses";
import { User } from "../../Models/APIGetData/User/User";
import BackendServices from "../Api/BackendService";
import ContentPage from "../ContentPage";
import userColumns from "./utils/userColumns";
import { UserUrls } from "../../views/UserManagement";
import { useSelector } from "react-redux";
import { RootState } from "../../store/reducers";

interface UserTableProps {
  readonly queryParams?: { [key: string]: any };
  readonly createUrl?: string;
  readonly subtitle?: string;
  readonly pagination?: Pagination
  readonly cacheMechanism?: boolean
}

const UserTable = ({
  queryParams = {},
  createUrl = UserUrls.create(),
  subtitle,
  pagination,
  cacheMechanism
}: UserTableProps) => {
      const [isMegatronFetaureOn, setisMegatronFetaureOn] = useState<boolean>(false);          
      const fetchisMegatronFetaureFlagAndLoadRoles = async () => {
        const megatronFeature = await isMegatronFeatureOn();
        setisMegatronFetaureOn(megatronFeature);
        
        axiosApi
        .get<string[]>(`${BackendServices.USER_SERVICE.USER}/getRolesForListFilter`)
        .then((response) => response.data)
        .then((roleData) =>
          roleData.reduce<{ [key: string]: string }>((acc, curr) => {
            acc[curr] = megatronFeature ? getRoleLabel(curr) : curr;
            return acc;
          }, {})
        )
        .then((roleData) => setRoles(roleData));
      };  

  const [roles, setRoles] = useState<{ [key: string]: string }>({});
  const organisationName: string = useSelector(
      (state: RootState) => state.userDetails.organisationName
    );
  useEffect(() => {
    fetchisMegatronFetaureFlagAndLoadRoles();
  }, []);


 
   const fetch = (
    params: DataTableQueryParams,
  ): Promise<{ data: UserRow[]; totalPages: number }> => {
    return axiosApi
    .get<SearchResponses<User>>(`${BackendServices.USER_SERVICE.USER}/list`, {
      params: { ...params, ...queryParams },
    })
    .then(({ data }) => ({
      totalPages: data.totalPages,
      data: data.resultsList.map(
        (user: User): UserRow => ({
          email: user.email,
          identificator: user.identificator,
          name: user.name,
          organisationName: user.organisations,
          roleName: getRoleLabel(user.roleName),
          status: user.status,
        })
      ),
    }));
  }


  const filterEnable: boolean = isBRCGSUser();


  return (
    <ContentPage title="Users" subtitle={subtitle}>
      <DataTable<UserRow>
        columns={userColumns()}
        fetchRemoteData={fetch}
        filters={{
          roleName: () => roles,
        }}
        toolBarOptions={{
          newEntityLink: {
            label: "Add User",
            link: createUrl,
          },
        }}
        archiveFilter={{
          enabled: filterEnable,
          title: "inactive",
          queryParam: "showInactive",
        }}
        pagination={pagination}
        cacheMechanism={cacheMechanism}
      />
    </ContentPage>
  );
};

export default UserTable;
